import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileTextIcon, BookIcon, GraduationCapIcon, MessageSquareIcon, BarChart2Icon, ClipboardCheckIcon, PackageIcon, HelpCircleIcon, ArrowRightIcon, SearchIcon, BellIcon, UserIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, ChevronRightIcon } from 'lucide-react';
export function CustomerSupportPage() {
  const navigate = useNavigate();
  // Mock data for recent claims
  const recentClaims = [{
    id: '202534704',
    type: 'Warranty',
    status: 'Approved',
    date: 'Jul 7, 2025',
    dealer: 'AGRO+ SRL'
  }, {
    id: '202528724',
    type: 'Missing part',
    status: 'Pending',
    date: 'Jun 30, 2025',
    dealer: 'ZEPPELIN'
  }, {
    id: '202523188',
    type: 'Warranty',
    status: 'Approved',
    date: 'Jun 27, 2025',
    dealer: 'YUGAGROPOLIV LLC'
  }];
  // Mock data for support metrics
  const supportMetrics = {
    openClaims: 37,
    resolvedClaims: 98,
    avgResponseTime: '3.2 days',
    totalDocuments: 256
  };
  return <div className="min-h-screen bg-gray-100" data-id="element-8036">
      {/* Header */}
      <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 text-white" data-id="element-8037">
        <div className="container mx-auto px-6 py-8" data-id="element-8038">
          <div className="flex justify-between items-center mb-6" data-id="element-8039">
            <h1 className="text-3xl font-bold" data-id="element-8040">Customer Support</h1>
            <div className="flex items-center space-x-4" data-id="element-8041">
              <div className="relative" data-id="element-8042">
                <input type="text" placeholder="Search support resources..." className="pl-10 pr-4 py-2 bg-blue-900/30 border border-blue-800/30 rounded-lg text-white placeholder-blue-300 w-64 focus:outline-none focus:ring-2 focus:ring-blue-500/50" data-id="element-8043" />
                <SearchIcon className="absolute left-3 top-2.5 text-blue-300" size={18} data-id="element-8044" />
              </div>
              <div className="relative" data-id="element-8045">
                <BellIcon size={22} className="text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-8046" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-8047">
                  2
                </span>
              </div>
              <div className="bg-blue-800/30 rounded-full w-9 h-9 flex items-center justify-center" data-id="element-8048">
                <UserIcon size={20} className="text-white" data-id="element-8049" />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-8050">
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-8051">
              <div className="bg-blue-800/30 p-3 rounded-lg mr-4" data-id="element-8052">
                <ClipboardCheckIcon size={24} className="text-blue-300" data-id="element-8053" />
              </div>
              <div data-id="element-8054">
                <p className="text-blue-300 text-sm" data-id="element-8055">Open Claims</p>
                <h3 className="text-3xl font-bold" data-id="element-8056">
                  {supportMetrics.openClaims}
                </h3>
              </div>
            </div>
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-8057">
              <div className="bg-teal-800/30 p-3 rounded-lg mr-4" data-id="element-8058">
                <CheckCircleIcon size={24} className="text-teal-300" data-id="element-8059" />
              </div>
              <div data-id="element-8060">
                <p className="text-blue-300 text-sm" data-id="element-8061">Resolved Claims</p>
                <h3 className="text-3xl font-bold" data-id="element-8062">
                  {supportMetrics.resolvedClaims}
                </h3>
              </div>
            </div>
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-8063">
              <div className="bg-amber-700/30 p-3 rounded-lg mr-4" data-id="element-8064">
                <ClockIcon size={24} className="text-amber-300" data-id="element-8065" />
              </div>
              <div data-id="element-8066">
                <p className="text-blue-300 text-sm" data-id="element-8067">Avg. Response Time</p>
                <h3 className="text-2xl font-bold" data-id="element-8068">
                  {supportMetrics.avgResponseTime}
                </h3>
              </div>
            </div>
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-8069">
              <div className="bg-indigo-800/30 p-3 rounded-lg mr-4" data-id="element-8070">
                <BookIcon size={24} className="text-indigo-300" data-id="element-8071" />
              </div>
              <div data-id="element-8072">
                <p className="text-blue-300 text-sm" data-id="element-8073">Support Documents</p>
                <h3 className="text-3xl font-bold" data-id="element-8074">
                  {supportMetrics.totalDocuments}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-6 py-8" data-id="element-8075">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-8076">
          {/* Left Column - Support Services */}
          <div className="lg:col-span-2 space-y-8" data-id="element-8077">
            <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-8078">
              Support Services
            </h2>
            {/* Claims Section */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200 hover:shadow-md transition-shadow" data-id="element-8079">
              <div className="p-6 border-b border-gray-100" data-id="element-8080">
                <div className="flex items-start" data-id="element-8081">
                  <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-8082">
                    <FileTextIcon size={24} className="text-blue-600" data-id="element-8083" />
                  </div>
                  <div className="flex-1" data-id="element-8084">
                    <h3 className="text-xl font-bold text-gray-800 mb-1" data-id="element-8085">
                      Claims Management
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-8086">
                      Submit and track warranty claims, missing parts, or
                      technical issues
                    </p>
                    <div className="flex flex-wrap gap-3" data-id="element-8087">
                      <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-sm flex items-center" onClick={() => navigate('/support/claims/new')} data-id="element-8088">
                        Report New Claim
                      </button>
                      <button className="px-4 py-2 bg-white border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition-colors shadow-sm flex items-center" onClick={() => navigate('/support/claims/reports')} data-id="element-8089">
                        View Claims Reports
                        <ChevronRightIcon size={18} className="ml-1" data-id="element-8090" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Recent Claims */}
              <div className="bg-gray-50 px-6 py-4" data-id="element-8091">
                <h4 className="text-sm font-medium text-gray-500 mb-3 flex items-center" data-id="element-8092">
                  <BarChart2Icon size={16} className="mr-2" data-id="element-8093" />
                  RECENT CLAIMS
                </h4>
                <div className="space-y-2" data-id="element-8094">
                  {recentClaims.map(claim => <div key={claim.id} className="flex items-center justify-between bg-white p-3 rounded-lg border border-gray-200" data-id="element-8095">
                      <div className="flex items-center" data-id="element-8096">
                        {claim.status === 'Approved' ? <CheckCircleIcon size={18} className="text-green-500 mr-2" data-id="element-8097" /> : claim.status === 'Pending' ? <ClockIcon size={18} className="text-amber-500 mr-2" data-id="element-8098" /> : <AlertCircleIcon size={18} className="text-red-500 mr-2" data-id="element-8099" />}
                        <div data-id="element-8100">
                          <div className="font-medium text-gray-800" data-id="element-8101">
                            {claim.id}
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-8102">
                            {claim.dealer} • {claim.date}
                          </div>
                        </div>
                      </div>
                      <div data-id="element-8103">
                        <span className={`text-xs px-2 py-1 rounded-full ${claim.status === 'Approved' ? 'bg-green-100 text-green-800' : claim.status === 'Pending' ? 'bg-amber-100 text-amber-800' : 'bg-red-100 text-red-800'}`} data-id="element-8104">
                          {claim.status}
                        </span>
                      </div>
                    </div>)}
                </div>
                <div className="mt-3 text-center" data-id="element-8105">
                  <button className="text-blue-600 text-sm font-medium hover:text-blue-800 flex items-center mx-auto" onClick={() => navigate('/support/claims/reports')} data-id="element-8106">
                    View All Claims
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-8107" />
                  </button>
                </div>
              </div>
            </div>
            {/* Knowledge Base Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-8108">
              {/* Aisco Library */}
              <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-teal-900 rounded-xl shadow-sm overflow-hidden text-white hover:shadow-lg transition-shadow border border-blue-800/30" data-id="element-8109">
                <div className="p-6" data-id="element-8110">
                  <div className="flex items-center mb-4" data-id="element-8111">
                    <div className="bg-blue-800/30 p-3 rounded-lg mr-3" data-id="element-8112">
                      <BookIcon size={24} className="text-white" data-id="element-8113" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-8114">Aisco | LIBRARY</h3>
                  </div>
                  <p className="mb-6 text-blue-200" data-id="element-8115">
                    Access our complete collection of product documentation,
                    technical manuals, catalogs, and brochures in multiple
                    languages.
                  </p>
                  <div className="mt-auto" data-id="element-8116">
                    <button className="w-full px-4 py-3 bg-blue-800/30 hover:bg-blue-800/50 border border-blue-700/30 rounded-lg transition-colors text-white font-medium flex items-center justify-center" data-id="element-8117">
                      Browse Documentation
                      <ArrowRightIcon size={18} className="ml-2" data-id="element-8118" />
                    </button>
                  </div>
                </div>
                <div className="bg-blue-900/50 px-6 py-3 flex justify-between items-center" data-id="element-8119">
                  <span className="text-sm text-blue-200" data-id="element-8120">
                    256 documents available
                  </span>
                  <span className="text-xs bg-blue-800/40 px-2 py-1 rounded-full text-blue-200" data-id="element-8121">
                    Updated Weekly
                  </span>
                </div>
              </div>
              {/* Aisco School */}
              <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 rounded-xl shadow-sm overflow-hidden text-white hover:shadow-lg transition-shadow border border-blue-800/30" data-id="element-8122">
                <div className="p-6" data-id="element-8123">
                  <div className="flex items-center mb-4" data-id="element-8124">
                    <div className="bg-indigo-800/30 p-3 rounded-lg mr-3" data-id="element-8125">
                      <GraduationCapIcon size={24} className="text-white" data-id="element-8126" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-8127">Aisco | SCHOOL</h3>
                  </div>
                  <p className="mb-6 text-blue-200" data-id="element-8128">
                    Enhance your technical skills with our expert-led courses.
                    Learn at your own pace and get certified on our irrigation
                    systems.
                  </p>
                  <div className="mt-auto" data-id="element-8129">
                    <button className="w-full px-4 py-3 bg-indigo-800/30 hover:bg-indigo-800/50 border border-indigo-700/30 rounded-lg transition-colors text-white font-medium flex items-center justify-center" data-id="element-8130">
                      Start Learning
                      <ArrowRightIcon size={18} className="ml-2" data-id="element-8131" />
                    </button>
                  </div>
                </div>
                <div className="bg-indigo-900/50 px-6 py-3 flex justify-between items-center" data-id="element-8132">
                  <span className="text-sm text-blue-200" data-id="element-8133">
                    24 courses available
                  </span>
                  <span className="text-xs bg-indigo-800/40 px-2 py-1 rounded-full text-blue-200" data-id="element-8134">
                    Certification Available
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* Right Column - Support Resources */}
          <div className="space-y-8" data-id="element-8135">
            <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-8136">
              Support Resources
            </h2>
            {/* Feedback Section */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200 hover:shadow-md transition-shadow" data-id="element-8137">
              <div className="p-6" data-id="element-8138">
                <div className="flex items-center mb-4" data-id="element-8139">
                  <div className="bg-purple-100 p-3 rounded-lg mr-3" data-id="element-8140">
                    <MessageSquareIcon size={24} className="text-purple-600" data-id="element-8141" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-8142">Feedback</h3>
                </div>
                <p className="text-gray-600 mb-6" data-id="element-8143">
                  Help us improve Aisco Workspace by sharing your experience and
                  suggestions.
                </p>
                <button className="w-full px-4 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors shadow-sm font-medium" data-id="element-8144">
                  Submit Feedback
                </button>
              </div>
            </div>
            {/* Quick Support Links */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200" data-id="element-8145">
              <div className="p-6" data-id="element-8146">
                <h3 className="text-lg font-bold text-gray-800 mb-4" data-id="element-8147">
                  Quick Support
                </h3>
                <div className="space-y-3" data-id="element-8148">
                  <a href="#" className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8149">
                    <div className="bg-blue-100 p-2 rounded-lg mr-3" data-id="element-8150">
                      <HelpCircleIcon size={20} className="text-blue-600" data-id="element-8151" />
                    </div>
                    <div data-id="element-8152">
                      <div className="font-medium text-gray-800" data-id="element-8153">FAQ</div>
                      <div className="text-xs text-gray-500" data-id="element-8154">
                        Frequently asked questions
                      </div>
                    </div>
                  </a>
                  <a href="#" className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8155">
                    <div className="bg-green-100 p-2 rounded-lg mr-3" data-id="element-8156">
                      <PackageIcon size={20} className="text-green-600" data-id="element-8157" />
                    </div>
                    <div data-id="element-8158">
                      <div className="font-medium text-gray-800" data-id="element-8159">
                        Parts Catalog
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-8160">
                        Browse replacement parts
                      </div>
                    </div>
                  </a>
                  <a href="#" className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8161">
                    <div className="bg-amber-100 p-2 rounded-lg mr-3" data-id="element-8162">
                      <ClipboardCheckIcon size={20} className="text-amber-600" data-id="element-8163" />
                    </div>
                    <div data-id="element-8164">
                      <div className="font-medium text-gray-800" data-id="element-8165">
                        Warranty Information
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-8166">
                        Warranty terms and conditions
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            {/* Contact Support */}
            <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 rounded-xl shadow-sm overflow-hidden text-white border border-blue-800/30" data-id="element-8167">
              <div className="p-6" data-id="element-8168">
                <h3 className="text-xl font-bold mb-4" data-id="element-8169">Need Help?</h3>
                <p className="text-blue-200 mb-6" data-id="element-8170">
                  Our support team is available to assist you with any questions
                  or issues.
                </p>
                <div className="space-y-3" data-id="element-8171">
                  <button className="w-full px-4 py-3 bg-white text-gray-900 rounded-lg hover:bg-gray-100 transition-colors font-medium" data-id="element-8172">
                    Contact Support
                  </button>
                  <button className="w-full px-4 py-3 bg-transparent border border-blue-700/50 text-white rounded-lg hover:bg-blue-800/20 transition-colors" data-id="element-8173">
                    Schedule a Call
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}